<ng-select *ngIf="wingsData.length" class="custom" appendTo="body" [items]="wingsData" [clearable]="false" [searchable]="false"  bindLabel="name" bindValue="id" [(ngModel)]="wingId" (change)="changeWingSelect()"></ng-select>          
